import createIcon from '../../createIcon';

/**
 * @component @name AlarmOn
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgNS43OUwxNy40IDEuOTNMMTYuMTEgMy40NkwyMC43MSA3LjMyTDIyIDUuNzlaTTcuODggMy40Nkw2LjYgMS45M0wyIDUuNzhMMy4yOSA3LjMxTDcuODggMy40NlpNMTIgNC4wN0M3LjAzIDQuMDcgMyA4LjEgMyAxMy4wN0MzIDE4LjA0IDcuMDIgMjIuMDcgMTIgMjIuMDdDMTYuOTcgMjIuMDcgMjEgMTguMDQgMjEgMTMuMDdDMjEgOC4xIDE2Ljk3IDQuMDcgMTIgNC4wN1pNMTIgMjAuMDdDOC4xMyAyMC4wNyA1IDE2Ljk0IDUgMTMuMDdDNSA5LjIgOC4xMyA2LjA3IDEyIDYuMDdDMTUuODcgNi4wNyAxOSA5LjIgMTkgMTMuMDdDMTkgMTYuOTQgMTUuODcgMjAuMDcgMTIgMjAuMDdaTTEwLjU0IDE0LjZMOC40MSAxMi40N0w3LjM1IDEzLjUzTDEwLjUzIDE2LjcxTDE2LjUzIDEwLjcxTDE1LjQ3IDkuNjVMMTAuNTQgMTQuNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AlarmOn = createIcon('AlarmOn', [
  [
    'path',
    {
      d: 'M22 5.79L17.4 1.93L16.11 3.46L20.71 7.32L22 5.79ZM7.88 3.46L6.6 1.93L2 5.78L3.29 7.31L7.88 3.46ZM12 4.07C7.03 4.07 3 8.1 3 13.07C3 18.04 7.02 22.07 12 22.07C16.97 22.07 21 18.04 21 13.07C21 8.1 16.97 4.07 12 4.07ZM12 20.07C8.13 20.07 5 16.94 5 13.07C5 9.2 8.13 6.07 12 6.07C15.87 6.07 19 9.2 19 13.07C19 16.94 15.87 20.07 12 20.07ZM10.54 14.6L8.41 12.47L7.35 13.53L10.53 16.71L16.53 10.71L15.47 9.65L10.54 14.6Z',
      key: 'yxd5s1',
    },
  ],
]);

export default AlarmOn;
